import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import fuse from '../../../_libs/redux-fusion';
import {getCollection, getId} from '../../../core-utilities/domain/ReduxUtils';
import {FeedList} from '../FeedList';


export const StreamedComponent = (state$, dispatch) => (props$) => {
  const userData$ = state$
    .map(state => state.model.user)
    .distinctUntilChanged(null, user => getId(user))
    .filter(user => !!user)
    .map(user => ({
      id: getId(user),
      collection: getCollection(user),
    }));

  return props$
    .combineLatest(
      userData$,
      (props, userData) => ({
        ...props,
        ...userData,
        isOwnFeed: false,
        init: true,
      }));
};

export const UserFeedListContainer = fuse(StreamedComponent)(FeedList);



// WEBPACK FOOTER //
// ./src/js/activity-feed/components/UserFeedList/UserFeedListContainer.js